import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=f945f720&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=f945f720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f945f720",
  null
  
)

export default component.exports